<template>
    <div class="top-breadcrumbs">
        <p @click="handleGoIndex">运营指南</p>
        <div class="breadcrumbs-icon"></div>
        <span>图片素材&项目资质</span>
    </div>
    <div class="cont top">
        <div class="title">图片素材尺寸</div>
        <p>1:1主图尺寸：建议尺寸 1080px*1080px，至多上传5张，仅支持jpg/png格式，大小1M内；</p>
        <img src="https://p6.moimg.net/mdwxapp/guide/qualification_1_1.png" style="width: 200px;" />
        <p class="img-desc">7:3主图尺寸：建议尺寸 1080px*462px，仅支持jpg/png，大小1M内；</p>
        <img src="https://p6.moimg.net/mdwxapp/guide/qualification_7_3.png" style="width: 500px;" />
        <p class="img-desc">详情页尺寸：建议宽度750px，仅支持jpg/png格式，大小1M内；</p>
        <img src="https://p6.moimg.net/mdwxapp/guide/qualification_750.png" style="width: 200px;" />
        <p class="img-desc">插入视频尺寸：推荐比例 16:9，格式 mp4，3-5 分钟最佳，不大于 2G；</p>
        <img src="https://p6.moimg.net/mdwxapp/guide/qualification_16_9.png" style="width: 356px;" />
    </div>
    <div class="cont">
        <div class="tab_title">提交文件资料时请注意以下事项：</div>
        <ul class="no">
            <li>文件资料及其扫描件要求必须真实、有效、完整、清晰，并确保在众筹项目成功结束之前保持资质证明文件持续合法有效。</li>
            <li>文件资料如涉及数家企业或个人，则相互关系必须明确清晰，并由各方签章确认（个人所签署文件，需保证为个人亲笔签署，并明示身份证号码）。</li>
            <li>IP衍生产品、联名产品等合作产品，需提供相关授权书或合作协议，授权链条必须完整有效，需体现原作版权方与发起方之间的完整授权链条。</li>
            <li>发起人需提供的相关文件资料包括但不限于本文件要求的所列项目，如国家法律法规及行政要求规定必须具有其他相关的文件资料时，发起人有义务配合及时补充提供。</li>
            <li>以下所提及证件，均需提供原件照片或扫描件。</li>
            <li>摩点网站内部相关原则、特殊流程有明确规定的，按相关原则流程执行。</li>
            <li>特殊情况下，摩点有权要求发起者补充提供特定回报产品的质检报告，特殊情况包括但不限于项目发生客诉、产品涉及名贵特殊材质等情况。</li>
            <li>因回报产品涉及特殊性质而延迟提供资质文件的项目，在发起者提供相关资质文件之前，摩点有权采取终止众筹项目、不予结算众筹资金等措施。</li>
            <li>除下述产品外，如果回报产品系属于国家强制性标准规定的产品，请提供最近一年内有效的经CMA或CNAS认证的检测机构出具的检测报告，检测报告要求：</li>
        </ul>
        <ul class="circle">
            <li>检测报告内容须包含品牌名称、产品名称和检测项目；</li>
            <li>检测机构资质：检测机构可在CMA或CNAS官网“获认可认证机构”列表查询验证；</li>
            <li>检测报告编号可在全国认证认可信息公共服务平台查询验证：<a href="http://cx.cnca.cn/CertECloud/index/index/page" target="_blank">http://cx.cnca.cn/CertECloud/index/index/page</a></li>
        </ul>
    </div>
    <div class="cont">
        <div class="title">3C产品</div>
        <div class="tab_title">资质要求：</div>
        <p>如果您所销售的产品属于《强制性产品认证管理规定》范围的产品，请提供：</p>
        <p>1.3C认证证书</p>
        <p>属于《强制性产品认证管理规定》范围的产品（CCC产品认证范围-16大类96种产品），需提供一份生产厂家的《中国国家强制性产品认证证书》即3C安全认证证书。</p>
        <p>如您需判断您所销售的产品是否为3C产品，可参考：</p>
        <p>1.《市场监管总局关于发布强制性产品认证目录描述与界定表的公告》：</p>
        <p><a href="https://www.cnca.gov.cn/zwxx/gg/zjgg/art/2023/art_31ce43f5837d408cb2023ec693615ada.html" target="_blank">https://www.cnca.gov.cn/zwxx/gg/zjgg/art/2023/art_31ce43f5837d408cb2023ec693615ada.html</a></p>
        <p>2.强制性产品认证目录描述与界定表（2023年修订）：</p>
        <p><a href="https://www.cnca.gov.cn/api-gateway/jpaas-web-server/front/document/download? fileUrl=YW5UzzlvCwcM%2FNHHX%2FtT6F5yXryzuRkKaR8xDXYwlU0XkgL29Ze1%2FR2OA6D2u5Ro6MBm4vHA1zCC5dlKhdDiNQ%2FpyN0YKmrD9zx0HBES0fcjSiP4c1tAvUIpr8PHpzvLCGK83c0I%2BG3N76%2B870OsqYRMvOJ%2FBg6jsc2HLJDotFc%3D& fileName=%E9%99%84%E4%BB%B62%EF%BC%9A%E5%BC%BA%E5%88%B6%E6%80%A7%E4%BA%A7%E5%93%81%E8%AE%A4%E8%AF%81%E7%9B%AE%E5%BD%95%E6%8F%8F%E8%BF%B0%E4%B8%8E%E7%95%8C%E5%AE%9A%E8%A1%A8%EF%BC%882023%E5%B9%B4%E4%BF%AE%E8%AE%A2%EF%BC%89.pdf" target="_blank">https://www.cnca.gov.cn/api-gateway/jpaas-web-server/front/document/download? fileUrl=YW5UzzlvCwcM%2FNHHX%2FtT6F5yXryzuRkKaR8xDXYwlU0XkgL29Ze1%2FR2OA6D2u5Ro6MBm4vHA1zCC5dlKhdDiNQ%2FpyN0YKmrD9zx0HBES0fcjSiP4c1tAvUIpr8PHpzvLCGK83c0I%2BG3N76%2B870OsqYRMvOJ%2FBg6jsc2HLJDotFc%3D& fileName=%E9%99%84%E4%BB%B62%EF%BC%9A%E5%BC%BA%E5%88%B6%E6%80%A7%E4%BA%A7%E5%93%81%E8%AE%A4%E8%AF%81%E7%9B%AE%E5%BD%95%E6%8F%8F%E8%BF%B0%E4%B8%8E%E7%95%8C%E5%AE%9A%E8%A1%A8%EF%BC%882023%E5%B9%B4%E4%BF%AE%E8%AE%A2%EF%BC%89.pdf</a></p>
    </div>
    <div class="cont">
        <div class="title">食品</div>
        <div class="tab_title">资质要求：</div>
        <p>1.如果您是食品经营者，请提供：</p>
        <p>-行业资质：《食品经营许可证》/《食品经营者备案凭证》。</p>
        <p>-商品资质：</p>
        <p>（1）生产厂商的《营业执照》；</p>
        <p>（2）生产厂商的《食品生产许可证》及其明细表，如生产厂商为小作坊，需提供《小作坊食品生产许可证》及其明细表；</p>
        <p>（3）产品标签中存在委托生产/采购关系的，需提供食品经营者和生产厂商之间完整的《委托加工协议》或《采购合作协议》等；</p>
        <p>2.如果您是食品生产者，请提供：</p>
        <p>-行业资质：《食品生产许可证》及其明细表，如您为小作坊，需提供《小作坊食品生产许可证》及其明细表。</p>
        <p>3.如果您所销售商品为进口食品，请提供：</p>
        <p>-行业资质：《食品经营许可证》/《食品经营者备案凭证》。</p>
        <p>-商品资质：</p>
        <p>（1）《进口货物报关单》：报关单上应展现对应品牌名称及商品名称；</p>
        <p>（2）《入境货物检验检疫证明》：需与报关单合同协议一致的检验检疫证明；</p>
        <p>（3）委托进口协议：如报关单上经营使用单位或收货单位不在授权链上，需提供委托进口协议。</p>
        <p>备注：</p>
        <p>1. 特定产区认证：若众筹项目为特定产区的特色产品，如阳澄湖大闸蟹，发起人需提供地理标志商品认证证明；</p>
        <p>2. 无公害农产品：声称无公害农产品认证的，需提供无公害农产品认证证书；</p>
        <p>3. 绿色食品：声称绿色食品认证的，需提供绿色食品认证证书；</p>
        <p>4. 有机食品：声称获得有机食品认证的，需提供有机食品认证证书；</p>
        <p>5. 保健食品：需提供《保健食品生产企业卫生许可证》或《保健食品GMP证书》，需具有“蓝帽子”标志和批准文号。</p>
    </div>
    <div class="cont">
        <div class="title">宠物食品</div>
        <div class="tab_title">资质要求：</div>
        <p>1.如果您为宠物食品生产者，请提供：</p>
        <p>-行业资质：《饲料生产许可证》。</p>
        <p>2.如果您为宠物食品经营者，请提供：</p>
        <p>-商品资质：</p> 
        <p>（1）生产厂商的《饲料生产许可证》；</p>
        <p>（2）如果您为宠物食品品牌商，须提供您与生产厂商间的《委托加工协议》；如果您非品牌商，须提供您与品牌商之间的《采购合作协议》；</p>
        <p>备注：</p>
        <p>（1）如发起者经营国产预混料、饲料添加剂的，需提供预混料、饲料添加剂生产厂商相应的产品批准文号；</p>
        <p>（2）如宠物食品为进口产品，需提交进口饲料登记证。</p>
    </div>
    <div class="cont">
        <div class="title">出版</div>
        <div class="tab_title">资质要求：</div>
        <p>1.如果您为出版物经营单位，请提供：</p>
        <p>-行业资质：《出版物经营许可证》。</p>
        <p>-商品资质：</p>
        <p>（1）图书类商品，请提供可公开查询的ISBN编号/CIP；</p>
        <p>（2）音像制品类商品，请提供可公开查询的ISRC编号。</p>
        <p>2.如果您为出版单位，请提供：</p>
        <p>-行业资质：《出版物经营许可证》或《图书/音像制品出版许可证》。</p>
        <p>-商品资质：</p>
        <p>（1）图书类商品，请提供可公开查询的ISBN编号/CIP；</p>
        <p>（2）音像制品类商品，请提供可公开查询的ISRC编号。</p>
        <p>3.如果您为出版物进口单位，请提供：</p>
        <p>-行业资质：《出版物经营许可证》。</p>
        <p>-商品资质：</p>
        <p>（1）出版物进口单位的审批文件；</p>
        <p>（2）某省/某市新闻出版局关于同意《XXXXXX》进口出版物备案的批复；</p>
        <p>（3）如出版物存在委托进口关系的，需提供经营主体和出版物进口单位之间的《委托进口协议》。</p>
        <p>注：如暂无书号可在首款结算之前先提供出版协议，于中款结算之前补充上传书号。</p>
    </div>
    <div class="cont">
        <div class="title">电子游戏</div>
        <div class="tab_title">资质要求：</div>
        <p>1.如果您所销售商品属于Steam电子游戏，请提供：</p>
        <p>（1）该游戏在steam平台发行的网页链接；</p>
        <p>（2）中款结算前，发起者需完成游戏上架，且支持者可在Steam平台兑换相应游戏产品。</p>
        <p>2.如果您所销售商品属于国产移动网络游戏，请提供：</p>
        <p>（1）《网络游戏出版物号（ISBN）核发单》；</p>
        <p>（2）《增值电信业务经营许可证》。</p>
    </div>
    <div class="cont">
        <div class="title">化妆品</div>
        <div class="tab_title">资质要求：</div>
        <p>1.如果您所销售商品为国产化妆品，请提供：</p>
        <p>（1）《国产非特殊用途化妆品备案凭证》（如所售商品为特殊用途化妆品，则需提供《国产特殊用途化妆品注册凭证》）；</p>
        <p>（2）生产厂商的《化妆品生产许可证》；</p>
        <p>（3）产品标签中存在委托生产关系的，需提供商品经营者和生产厂商之间的《委托加工协议》。</p>
        <p>2.如果您所销售商品为进口化妆品，请提供：</p>
        <p>（1）《进口非特殊用途化妆品备案凭证》（如所售商品为进口特殊用途化妆品，则需提供《进口特殊用途化妆品注册凭证》）；</p>
        <p>（2）《进口货物报关单》：报关单上应展现对应品牌名称及商品名称；</p>
        <p>（3）《入境货物检验检疫证明》：需与报关单合同协议一致的检验检疫证明；</p>
        <p>（4）委托进口协议：如报关单上经营使用单位或收货单位不在授权链上，需提供委托进口协议。</p>
        <p>备注：</p>
        <p>（1）特殊用途化妆品，是指用于染发、烫发、祛斑美白、防晒、防脱发的化妆品以及宣称新功效的化妆品为特殊化妆品。特殊化妆品以外的化妆品为普通化妆品；</p>
        <p>（2）如为您所售产品为特殊用途化妆品，还需提供特殊用途化妆品卫生许可批件；</p>
        <p>（3）化妆品备案电子凭证的当前备案状态不得为“已注销”。</p>
    </div>
    <div class="cont">
        <div class="title">贵重金属、特殊材质</div>
        <div class="tab_title">资质要求：</div>
        <p>如果您所销售商品属于贵金属、名贵木材、真皮等特殊材质商品（如925/999纯银、黄金、钻石、玉石、翡翠、猛犸象牙、紫檀木、花梨木、真丝、真皮等），请提供：</p>
        <p>第三方权威质检机构出具的含有CMA或CNAS认证的材质质检报告或者鉴定证书（正反面）。</p>
    </div>
    <div class="cont">
        <div class="title">消毒产品</div>
        <div class="tab_title">资质要求：</div>
        <p>1.如果您为消毒产品生产者，请提供：</p>
        <p>-行业资质：《卫生许可证》。</p>
        <p>-商品资质：消毒产品卫生安全评估报告，或在消毒产品网上备案信息服务平台公开查询截图。</p>
        <p>2.如果您为消毒产品经营者，请提供：</p>
        <p>-商品资质：</p>
        <p>（1）产品生产厂商的《卫生许可证》；</p>
        <p>（2）消毒产品卫生安全评估报告，或在消毒产品网上备案信息服务平台公开查询截图。</p>
    </div>
    <div class="cont">
        <div class="title">农药产品</div>
        <div class="tab_title">资质要求：</div>
        <p>涉及国产花露水、驱蚊产品、蚊香、杀蟑胶饵产品，资质要求：</p>
        <p>1.如果您为产品生产者，请提供：</p>
        <p>-行业资质：《农药产品生产许可证》或《农药生产批准证书》。</p>
        <p>-商品资质：《农药登记证》。</p>
        <p>2.如果您为产品经营者，请提供：</p>
        <p>-商品资质：</p>
        <p>（1）生产厂商的《农药产品生产许可证》或《农药生产批准证书》；</p>
        <p>（2）产品标签中存在委托生产/采购关系的，需提供食品经营者和生产厂商之间完整的《委托加工协议》或《采购合作协议》等；</p>
        <p>（3）《农药登记证》。</p>
    </div>
    <div class="cont">
        <div class="title">活动</div>
        <div class="tab_title">资质要求：</div>
        <p>（1）项目上线需要场地租赁协议；</p>
        <p>（2）如活动参加者人数达1000以上，中款结算前，发起者需向公安机关申报，并在活动举办前将活动批文扫描件提供给摩点平台；</p>
        <p>（3）如包含演出，还需提供营业性演出许可证和文化报批文件。</p>
    </div>
    <div class="cont">
        <div class="title">非物质文化遗产传承人</div>
        <div class="tab_title">资质要求：</div>
        <p>提供非物质文化遗产传承人证书（国家/省级/市级/县级）。</p>
    </div>
    <div class="cont">
        <div class="title">影视</div>
        <div class="tab_title">资质要求：</div>
        <p>电影：需提供电影发行经营许可证和电影公映许可证。</p>
        <p>电视剧：需提供电视剧发行许可证。</p>
        <p>影视衍生品：仅销售周边衍生品不需要上述许可证。</p>
    </div>
    <div class="cont">
        <div class="title">承诺公益捐赠时</div>
        <div class="tab_title">资质要求：</div>
        <p>需在中款结算之前上传捐赠协议或发票凭证。</p>
    </div>
    <div class="cont">
        <div class="title">团队成员</div>
        <div class="tab_title">资质要求：</div>
        <p>页面如有除发起方之外的其他人员或公司，需邀请其加入项目团队成员并完成摩点账号实名认证，或上传合作协议。</p>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
const handleGoIndex = () => {
    if(sessionStorage.getItem('guide_pro_id')){
        router.push(`/project_manage/index/${sessionStorage.getItem('guide_pro_id')}`)
    } else {
        router.push((`/project_manage/index`))
    }
}
</script>

<style lang="scss" scoped>
.top-breadcrumbs{
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    padding: 0 0 40px 0;
    p{
        color: #7F7F7F;
        cursor: pointer;
    }
    .breadcrumbs-icon{
        width: 14px;
        height: 14px;
        margin: 0 10px;
        background: url('~@/assets/images/icon_right.png') no-repeat center center;
        background-size: contain;
    }
    span{
        color: #1A1A1A;
    }
}
.cont{
    margin: 60px 0 0 0;
    color: #1A1A1A;
    &.top{
        margin: 0;
    }
    &.img{
        .title{
            margin: 0;
        }
    }
    .tab_title{
        font-weight: 600;
        margin: 0 0 15px 0;
    }
    .title{
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 20px 0;
    }
    a{
        color: #425EB2;
    }
    p{
        font-size: 14px;
        line-height: 21px;
        &.img-desc{
            padding: 40px 0 0 0;
        }
        span{
            font-weight: 600;
        }
    }
    img{
        margin: 15px 0 0 0;
        width: 100%;
        height: auto;
    }
    ul{
        padding: 0 0 0 20px;
        line-height: 21px;
        li{
            font-size: 14px;
            line-height: 21px;
        }
        
        &.no{
            list-style-type: decimal;
            li{
                list-style: decimal;
            }
        }
        
        &.circle{
            list-style-type: disc;
            li{
                list-style: disc;
            }
        }
    }
}
</style>